import { Base } from "../../framework/base";
var EditItem = /** @class */ (function () {
    function EditItem(obj) {
        this.id = obj && obj.id || "";
        this.rowId = obj && obj.rowId || "";
    }
    EditItem.prototype.isNew = function () {
        return !this.rowId;
    };
    EditItem.prototype.getHash = function () {
        var _a, _b;
        return ((_a = this.id) !== null && _a !== void 0 ? _a : "") + "#" + ((_b = this.rowId) !== null && _b !== void 0 ? _b : "");
    };
    EditItem.getHash = function (items) {
        if (!items || items.length < 1)
            return "";
        return Base.joinSuffix(items.map(function (i) { return i.getHash(); }), "$");
    };
    EditItem.setItemIdsFromIds = function (items, ids) {
        if (items.length < 0 || ids.length < 0)
            return;
        for (var i = 0; i < Math.min(items.length, ids.length); i++) {
            items[i].id = ids[i];
        }
    };
    return EditItem;
}());
export { EditItem };
